import { useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Home,
    Headset,
    Gift,
    User,
    LogIn,
    Search,
    Book,
} from 'lucide-react';
import { useAuth } from '../../../hooks/contexts/AuthContext';

const navItems = [
    { label: 'Home', icon: Home, route: '/' },
    { label: 'Support', icon: Headset, route: '/contactus' },
    { label: 'Gift Cards', icon: Gift, route: '/card-list?category=apparel' },
    { label: 'Search', icon: Search, route: '/search', guestOnly: true },
    { label: 'Order', icon: Book, route: '/profile/order', auth: true },
    { label: 'Profile', icon: User, route: '/profile', auth: true },
    { label: 'Login', icon: LogIn, route: '/login', guestOnly: true },
];

export default function MobileFooterNavigation() {
    const [currentPath, setCurrentPath] = useState('/');
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        setCurrentPath(location?.pathname);
    }, [location.pathname]);


    const handleFooterNavigation = (switchMe) => {
        navigate(switchMe, { replace: true });
    }

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: "white.main",
                height: 75,
                py: 1,

                // borderRadius: "16px 16px 0 0",
                // borderTop: 1.5,
                // borderColor: "primary.main",
            }}
        >
            <Box
                component={"div"}
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, 1fr)",
                    height: 50,
                }}
            >
                {navItems.map((item) => {
                    if (item?.auth && !isLoggedIn) return null;
                    if (item?.guestOnly && isLoggedIn) return null;

                    // const isActive = (() => {
                    //     const basePath = item?.route?.split('?')[0];
                    //     if (item?.route === '/') {
                    //         return currentPath === '/';
                    //     }
                    //     return currentPath.startsWith(basePath);
                    // })();


                    const isActive = (() => {
                        const basePath = item?.route?.split('?')[0];

                        if (item?.route === '/') return currentPath === '/';

                        // For known parent-child conflicts like /profile vs /profile/order
                        if (['/profile', '/profile/order'].includes(basePath)) {
                            return currentPath === basePath;
                        }

                        return currentPath.startsWith(basePath);
                    })();

                    return (
                        <Box
                            key={`mobile-footer-navigation-${item?.label}`}
                            component={"div"}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <MobileFooterButton
                                IconComponent={item.icon}
                                active={isActive}
                                lable={item.label}
                                route={item.route}
                                onHandler={handleFooterNavigation}
                            />

                            <Typography variant='subtitle2'>
                                {item.label}
                            </Typography>
                        </Box>
                    );
                })
                }

            </Box>
        </Box>
    );
}

const MobileFooterButton = ({ IconComponent, active, route, lable, onHandler }) => {
    const baseStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        borderRadius: '50%',
        transition: 'all 0.3s ease',
    };

    const activeStyles = {
        backgroundColor: 'primary.main',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        transform: 'scale(1.3)',
        position: 'relative',
        top: -25,
        "&:hover": {
            backgroundColor: 'primary.main',
        }
    };

    const iconStyle = {
        color: active ? '#fff' : '#000',
        width: 24,
        height: 24,
    };

    return (
        <IconButton
            aria-label={`${lable}`}
            sx={{
                ...baseStyles,
                ...(active ? activeStyles : {}),
            }}
            onClick={() => onHandler(route)}
        >
            <IconComponent style={iconStyle} />
        </IconButton>
    );
};